<div class="checkbox-container" [class.has-error]="hasError()">
  <div class="checkbox-wrapper d-flex align-items-center" [class.label-before]="labelPosition === 'before'">
    <!-- Label before checkbox -->
    <label *ngIf="label && labelPosition === 'before'" [for]="id || name" class="checkbox-label" (click)="onLabelClick()">
      {{ label }}
      <span *ngIf="required" class="required-indicator">*</span>
    </label>

    <!-- Material Checkbox -->
    <mat-checkbox
      [id]="id || name"
      [name]="name"
      [required]="required"
      [disabled]="disabled"
      [color]="color"
      [checked]="value"
      [indeterminate]="indeterminate"
      [class]="'checkbox-input ' + class"
      (change)="onCheckboxChange($event)"
      (blur)="onBlur()"
    >
    </mat-checkbox>

    <!-- Label after checkbox -->
    <label *ngIf="label && labelPosition === 'after'" [for]="id || name" class="checkbox-label" (click)="onLabelClick()">
      {{ label }}
      <span *ngIf="required" class="required-indicator">*</span>
    </label>
  </div>

  <!-- Description -->
  <div *ngIf="description" class="checkbox-description">
    {{ description }}
  </div>

  <!-- Error message -->
  <div *ngIf="hasError()" class="error-message">
    {{ getErrorMessage() }}
  </div>
</div>
